import React, {
  useState,
  Component,
  useEffect,
  useRef,
  useContext,
} from "react";
import {
  bearlog,
  BearDiv,
  BearPage,
  BearList,
  BearBackBorder,
  BearSelect,
  BearFloat,
  BearNavigation,
  BearBorder,
} from "@sillyscribe95/bear-ui-web";
import { instConst, instuArray } from "../consts/instConst";
import { MainContext } from "../context/MainContext";
import { EmojiPage } from "./EmojiPage";
import { PageMain } from "./PageMain";

import MIDISounds from "midi-sounds-react";
// import { useMIDI } from "@react-midi/hooks";
import { MidiComp } from "./MidiComp";
import { KeyShift } from "../components/KeyShift";
import { KeyComp } from "./KeyComp";
import { InstComps } from "../components/InstComps";
import { KeyChoose } from "../components/KeyChoose";
import { InstChoose } from "../components/InstChoose";
import { getKeyChord } from "../consts/chordConst";
import { KeyboardComp } from "./KeyboardComp";
import { KeyboardBase } from "./KeyboardBase";
import { ShareComp } from "../components/ShareComp";
import { HomeMobile } from "./HomeMobile";
import { HomeDesktop } from "./HomeDesktop";
import { mobView } from "../consts/mainConst";

export function HomePage(aaaa) {
  bearlog.lug("___ aaaa ___", aaaa);

  const {
    //
    match: {
      params: { key, inst },
    },
    ...args
  } = aaaa;

  const {
    //
    setisnSound,
    reffo,
    playMain,
    picho,
    shiftpic,
  } = useContext(MainContext);

  useEffect(() => {
    if (key) {
      shiftpic(getKeyChord(key));
    }

    if (inst) {
      setisnSound(inst);
    }
  });

  //   1top

  // 1midi
  const { inputs, outputs, hasMIDI } =
    //
    [];
  // useMIDI();
  let input =
    //
    "";
  // inputs[0];
  bearlog.lug("___ inputs, outputs, hasMIDI ___", { inputs, outputs, hasMIDI });

  const isjdr = {
    ref: reffo,
    appElementName: "root",
  };

  const ijfwe = <MIDISounds {...isjdr} />;

  const asde = { input };
  const { config, item } = mobView ? HomeMobile(asde) : HomeDesktop(asde);

  const jssde = {
    ...config,
  };

  // 1play

  return (
    <PageMain {...jssde}>
      {item}
      {ijfwe}
    </PageMain>
  );
}
